import { extractUserSet } from "../api";
import { SqlDataTable } from "../components/SqlDataTable";
import { SqlPieChart } from "../components/SqlPieChart";
import { openExportUsersModal } from "@/components/elements/ExportUsersModal";

interface Data { name: string, value: number };

const dataQuery = `
select label as name,
count(distinct  user_id) as value
from events where type = 'event'
and label in ('visit-subscribe', 'start-subscribe', 'cancel-subscribe', 'error-subscribe', 'finish-subscribe' )
and epoch_ms(ts) > (now() - INTERVAL 7 DAY)
group by label
order by name
`;

const extractUsersQuery = `
select distinct user_id
from events where type = 'event'
and label = ?
and epoch_ms(ts) > (now() - INTERVAL 7 DAY)
`

export function SubscriberBreakdownChart() {
  return <SqlDataTable
    label="Subscribe Breakdown"
    subtext="The total users who made it to each step of the subscribe flow: visit-subscribe -> start-subscribe -> finish-subscribe. (Last 7 days)"
    width={900}
    onClick={(data: Data) => {
      let users: Set<string>;
      openExportUsersModal({
        headerContent: <>
          Includes only users in the <b>{data.name}</b> step.
        </>,
        onDownload: async () => {
          users = await extractUserSet(extractUsersQuery, [data.name])
        },
        beforeCsv: async (exportUsers) => {
          return exportUsers.filter(u => users.has(u.id));
        }
      })
    }}
  >{dataQuery}</SqlDataTable>
}